import styled from 'styled-components';

const AboutUsStyled = styled.div`
    /* 18-11-2022 */
    padding: 240px 15px 50px;
    position: relative;
    overflow-y: hidden;
    z-index: 1;
    
    @media (max-width: 1199.99px){
        padding: 210px 15px 0;
    }

    @media (max-width: 991px){
        padding: 180px 15px 0;        
    }

    @media (max-width: 767px){
        padding: 110px 15px 0;
    }

    .right_side_imageDesign,.left_side_imageDesign{
        z-index: -1;
    } 
    p { 
        font-size: 25px;
        color: #000;
        @media (max-width: 1500px){
            font-size: 22px;
        }
        @media (max-width: 1280px){
            margin-bottom: 40px;
            font-size: 20px;
        } 
        @media (max-width: 767px){
            font-size: 18px;
            margin-bottom: 15px;
            line-height: normal;
        } 
    }
    .about-us {
            width: 100%;
            max-width: 1040px;
            padding: 0 15px;
            margin: 0 auto;
        .top_section {
            text-align: center;
            .first_section {
                margin-bottom: 35px;
                @media (max-width: 767px){
                    margin-bottom: 20px;
                    }
                h2 {
                    color: #00a6e7;
                    margin-bottom: 0;
                    @media (max-width: 767px){
                        font-size: 20px;
                    }
                }
            }
        }
        @media (max-width: 1199.99px){
            background: #cfd7dbd6;
            padding: 20px 10px;
        }
    }
    .main_container {
        .passage_container {
            margin-bottom: 70px;
            @media (max-width: 991px){
                margin-bottom: 40px;
            }
            .text_section {
                p {
                    margin-bottom: 30px;
                    @media (max-width: 767px){
                        margin-bottom: 15px;
                        font-size: 18px;
                        line-height: normal;
                    }
                } 
            }
            .image_section {
                margin-bottom: 20px;
                @media (max-width: 991px){
                    margin-bottom: 10px;
                }
                .image_border {
                    background: linear-gradient(90deg,#e40685 0%,#bd1b86 21%,#632e8a 100%);
                    padding: 7px 7px;
                    width: 100%;
                    max-width: 220px;
                    border-radius: 125px;
                    height: 220px;
                    overflow: hidden;
                    @media (max-width: 991px){
                        max-width: 160px;
                        height: 160px;
                        @media (max-width: 767px){
                            max-width: 130px;
                            height: 130px;
                        }
                        img{
                            width: 100%;
                        }
                    }

                    img {
                        height: 100%;
                        width:100%;
                        object-fit: cover;
                        border-radius: 100%;
                    }
                }
               
            }

            .headings {
                .orange {
                    color: #ea5a24;
                    font-size: 40px;
                    margin-bottom: 0;
                    @media (max-width: 991px){
                        font-size: 34px;
                        margin-bottom: 0;
                    }
                    @media (max-width: 991px){
                        font-size:  24px; 
                    } 
                }
                .team-founder {
                    margin: 10px 0 25px;
                    font-size: 27px;
                    font-weight: 600;
                    color: #000;
                    @media (max-width: 767px){
                        margin: 10px 0 15px;
                        font-size: 22px
                    }
                }
            }
        }
    }

    @media (max-width: 1200px){
        .about-us{
            h2 {
                font-size: 32px;
                @media (max-width: 991px){
                    font-size: 28px;
                }
                @media (max-width: 767px){
                        font-size: 24px;
                }
            }
        }
    
    }
`;

export default AboutUsStyled;